import { VideoCompressor } from '@/components/VideoCompressor';

const VideoCompressorPage = () => {
  return <VideoCompressor />;
};

export default VideoCompressorPage;